import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';

import { i18nIntl, adaptHeightOnWidget, getRemotedbUrl } from '../../lib/ep.js';

import SearchField from '../builder/SearchField';
import Spinner from '../builder/Spinner';

import InfiniteScroll from '../hoc/InfiniteScroll';

import UserAvatar from '../front/UserAvatar';
import { useThrottle } from '../../lib/hooks.js';

const Wrapper = ({ model, change, ...props }) => {
	return (
		<div class="gui_ranking">
			<div class="gui_search">
				<SearchField
					name="search_value"
					placeholder="Search by name"
					model={model}
					change={change}
					_class={{ size:50, other:'gui_flex_center' }}
				/>
			</div>

			<div>
				{props.children}
			</div>
		</div>
	)
};

const SingleParticipant = ({ user, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const getRealName = () => {
		if(user.first_name || user.last_name) return `${user.first_name} ${user.last_name}`;
		if(user.username) return user.username;
		if(user.name) return user.name;
		return i18n("Unknown");
	};

	return (
		<tr>
			<td>
				<div>
					<div class="gui_participant_avatar gui_only_wide_screen">
						<UserAvatar
							user={user}
						/>
					</div>

					<p class="gui_participant_name hb_mainFontWeightBold">
						<span class="gui_cutTextOnOverflow">{getRealName()}</span>
					</p>
				</div>
			</td>

			<td class="gui_only_wide_screen">
				<div class="gui_text_align_center">
					<p style={{ width:'100%' }}>{EPDateFormat(user.created, "L LT")}</p>
				</div>
			</td>
		</tr>
	)
};

const CurrentUsers = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ loaded, setLoaded ] = useState(false);
	const [ participants, setParticipants ] = useState(props?.participants ?? []);

	const [ filter_model, setFilterModel ] = useState({ search_value:'' });

	const promotion = props?.promotion ?? false;
	const is_builder = props?.is_builder ?? false;

	useEffect(() => {
		fetchParticipants(1, (d) => fetched(d.data));
		adaptHeightOnWidget();
	}, []);

	if(promotion === false) return null;

	const fetched = (data) => {
		setParticipants(participants.concat(data));
		if(!loaded) setLoaded(true);
	};

	const fetchParticipants = (page, cb, search_value) => {
		const d = {};
		if(page) d.page = page;

		const search = (search_value != '') ? search_value : false;
		if(search !== false) d.search = search;

		if(is_builder) {
			setLoaded(true);
			cb({ data:(props?.participants ?? []).sort((a, b) => (a.User.points < b.User.points ? 1 : -1)), hasMore:false });
			return;
		}

		$.get(getRemotedbUrl(`/users/current_users/${promotion.id}`), d, (result) => {
			setLoaded(true);
			if(cb) cb({ data:result.entries, hasMore:false });
		}, 'JSON');
	};
	
	const change_and_search = (k,v) => {
		setFilterModel({ ...filter_model, [k]:v });
		setLoaded(false);
		delayed_search(v);
	}

	const search = (v) => {
		setParticipants([]);
		fetchParticipants(1, (d) => fetched(d.data), v);
	};

	const delayed_search = useThrottle((v) => search(v), 500);


	if(!loaded) {
		<Wrapper
			model={filter_model}
			change={change_and_search}
		>
			<div class="is_loading_contents" style={{ height:'200px' }}>
				<Spinner>Loading last users</Spinner>
			</div>
		</Wrapper>
	}

	if(participants.length == 0) {
		return (
			<Wrapper
				model={filter_model}
				change={change_and_search}
			>
				<div class="gui_not_in_top_big">
					<p>{i18n("There are no participants")}</p>
				</div>
			</Wrapper>
		)
	}

	return (
		<Wrapper
			model={filter_model}
			change={change_and_search}
		>
			<div class="gui_not_in_top_big">
				<InfiniteScroll
					fetch={(p, cb) => fetchParticipants(p, cb)}
					fetched={fetched}
					_maxHeight={{ minHeight:'500px' }}
					scroll_on_document={true}
				>
					<table cellSpacing="0" cellPadding="0" style={{ width:'100%' }}>
						<thead>
							<tr>
								<th class="hb_secondaryFont" width="50%">{i18n("Participants")}</th>

								<th class="hb_secondaryFont gui_only_wide_screen gui_text_align_center">{i18n("Date and time")}</th>
							</tr>
						</thead>

						<tbody>
							{participants.map((participant) => {
								const user = participant.User;

								return (
									<SingleParticipant
										key={user.id}
										user={user}
										intl={props.intl}
									/>
								)
							})}
						</tbody>
					</table>
				</InfiniteScroll>
			</div>
		</Wrapper>
	)
};

export default injectIntl(CurrentUsers);